<template lang="html">
  <div
    class="extension-new"
    v-if="isAdmin">
    <a
      href="#"
      class="btn btn-primary"
      @click.prevent="newExtensionModal">Novo Ramal</a>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      ref="newExtensionModal"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Criar novo Ramal</h5>
            <button
              type="button"
              class="close"
              @click.prevent="closeNewExtensionModal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <form
              ref="newExtensionForm"
              class="new-extension-form"
              @keydown.enter.prevent="createNewExtension">
              <div
                v-if="error"
                class="alert alert-danger"
                role="alert">
                {{ error.message }}
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <i class="input-group-text ik ik-phone" />
                  </div>
                  <input
                    ref="extension"
                    type="text"
                    class="form-control"
                    id="extension"
                    autocomplete="extension"
                    placeholder="Número do ramal"
                    v-model="extension"
                    required>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <i class="input-group-text ik ik-lock" />
                  </div>
                  <input
                    ref="password"
                    id="password"
                    type="password"
                    class="form-control"
                    autocomplete="new-password"
                    placeholder="Senha"
                    v-model="password"
                    required>
                  <span class="input-group-append">
                    <a
                      class="input-group-text"
                      href="#"
                      @click.prevent="togglePasswordVisibility()">
                      <i class="ik ik-eye" />
                    </a>
                  </span>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click.prevent="closeNewExtensionModal">Cancelar</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="createNewExtension">Criar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="newExtensionSuccess"
      ref="newExtensionSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Novo ramal criado</h5>
            <button
              type="button"
              class="close"
              @click.prevent="closeNewExtensionSuccessModal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div
              class="alert alert-success"
              role="alert">
              Seu ramal {{ extension }} foi criado com sucesso!
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="closeNewExtensionSuccessModal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'

export default {
  name: 'ExtensionNew',
  data () {
    return {
      error: null,
      extension: null,
      password: null
    }
  },
  methods: {
    newExtensionModal () {
      this.error = null
      this.$refs.newExtensionForm.reset()
      $(this.$refs.newExtensionModal).modal('show')
      setTimeout(_ => {
        this.$refs.extension.focus()
      }, 1000)
    },
    closeNewExtensionModal () {
      $(this.$refs.newExtensionModal).modal('hide')
    },
    closeNewExtensionSuccessModal () {
      $(this.$refs.newExtensionSuccess).modal('hide')
    },
    createNewExtension () {
      const form = this.$refs.newExtensionForm
      this.error = null
      if (form.checkValidity()) {
        loopback
          .post('/extensions', {
            ramal: this.extension,
            senha: this.password,
            gravar_audio: true
          })
          .then(newExtension => {
            if (newExtension && newExtension.id) {
              $(this.$refs.newExtensionModal).modal('hide')
              $(this.$refs.newExtensionSuccess).modal('show')
              EventBus.$emit('new-extension-added', newExtension)
            }
          })
          .catch(err => {
            if (err && err.details && err.details.messages && err.details.messages.ramal) {
              this.error = { message: `Número do ramal ${err.details.messages.ramal[0]}` }
            } else if (err && err.code === 'ER_DUP_ENTRY') {
              this.error = { message: 'Ramal já criado' }
            } else {
              this.error = err
            }
          })
      } else {
        this.error = {
          message: 'Os campos ramal, senha e permissões são obrigatórios'
        }
      }
    },
    togglePasswordVisibility () {
      const input = $('#password')
      if (input[0].type === 'password') {
        input[0].type = 'text'
      } else {
        input[0].type = 'password'
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Extension/New.vue